import React, { useState } from 'react';

import { Button } from '@mantine/core';
import { IconClock } from '@tabler/icons-react';

import WorkoutTimer from './WorkoutTimer';

function WorkoutTimerButton(): JSX.Element {
  const [opened, setOpened] = useState(false);

  if (opened) {
    return <WorkoutTimer onClose={() => setOpened(false)} />;
  }

  return (
    <Button variant='default' leftIcon={<IconClock size={16} />} onClick={() => setOpened(true)}>
      Timer
    </Button>
  );
}

export default WorkoutTimerButton;
